import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import AuthCallback from "@/pages/AuthCallback";
import Home from "@/pages/Home";
import Explore from "@/pages/Explore";
import OpportunityDetails from "@/pages/OpportunityDetails";
import PostTask from "@/pages/PostTask";
import Messages from "@/pages/Messages";
import ChatRoom from "@/pages/ChatRoom";
import Profile from "@/pages/Profile";
import VolunteerHours from "@/pages/VolunteerHours";
import { Toaster } from "@/components/ui/sonner";

function AppRouter() {
  const location = useLocation();

  // Check URL fragment for session_id synchronously during render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/dashboard" element={<ProtectedRoute><Layout><Home /></Layout></ProtectedRoute>} />
      <Route path="/explore" element={<ProtectedRoute><Layout><Explore /></Layout></ProtectedRoute>} />
      <Route path="/opportunities/:id" element={<ProtectedRoute><Layout><OpportunityDetails /></Layout></ProtectedRoute>} />
      <Route path="/post-task" element={<ProtectedRoute><Layout><PostTask /></Layout></ProtectedRoute>} />
      <Route path="/messages" element={<ProtectedRoute><Layout><Messages /></Layout></ProtectedRoute>} />
      <Route path="/messages/:threadId" element={<ProtectedRoute><Layout><ChatRoom /></Layout></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><Layout><Profile /></Layout></ProtectedRoute>} />
      <Route path="/profile/:userId" element={<ProtectedRoute><Layout><Profile /></Layout></ProtectedRoute>} />
      <Route path="/hours" element={<ProtectedRoute><Layout><VolunteerHours /></Layout></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
